import React, { useEffect } from "react";
import { App } from "@version2/ui-package";
import { bindMessageInstance } from "../../../Services/messageBridge";

type Props = {
  children: React.ReactNode;
};

const AntdMessageContextBridge = ({ children }: Props) => {
  const { message: messageApi } = App.useApp();

  useEffect(() => {
    bindMessageInstance(messageApi);
  }, [messageApi]);

  return <>{children}</>;
};

export default AntdMessageContextBridge;
